import {AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {NumberPickerConfig} from './number-picker.config';
import {NumberPickerEvent} from '../number-picker-event';
import {NumberPickerHammerConfig} from '../number-picker-hammer.config';



@UntilDestroy()
@Component({
    selector: 'mydocma-form-number-picker',
    templateUrl: './number-picker.component.html',
    styleUrls: ['./number-picker.component.scss'],
})
export class NumberPickerComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('ref') container: ElementRef;
    public items: number[] = [];
    public selectedItem: number;

    private hammerInstance;
    private scrollDownListner;
    private scrollUpListner;

    constructor(@Inject(MAT_DIALOG_DATA) public data: NumberPickerConfig,
                public dialogRef: MatDialogRef<NumberPickerComponent>,
                public dialog: MatDialog) {
        this.dialogRef.backdropClick()
        .pipe(untilDestroyed(this))
        .subscribe(value => {
            this.dialogRef.close();
            this.hammerInstance?.off('panup',  this.scrollDownListner);
            this.hammerInstance?.off('pandown',this.scrollUpListner);
            this.hammerInstance?.destroy();

        })
    }

    ngOnDestroy(): void {
    }

    ngOnInit() {
        this.selectedItem = this.data.value;
        this.setNumberPickerValue(this.data.value);
    }


    public setValue(): void {
        this.dialogRef.close(this.selectedItem);
    }

    public cancel(): void {
        this.dialogRef.close();
    }

    public onItemClick(item: number): void {
        this.selectedItem = item;
        this.setNumberPickerValue(item);
    }

    ngAfterViewInit(): void {
        const config = new NumberPickerHammerConfig();

        this.scrollDownListner = this.scrollDown.bind(this);
        this.scrollUpListner = this.scrollUp.bind(this);

        this.hammerInstance = config.buildHammer(this.container.nativeElement);
        this.hammerInstance.on('panup',  this.scrollDownListner);
        this.hammerInstance.on('pandown',this.scrollUpListner);
    }

    private scrollUp($event): void {
        const countItems = this.checkDistance($event)
        for (let i = 0; i < countItems; i++) {
            if (!isNaN(this.data?.minValue) && this.items[4] < this.data?.minValue) {
                return
            } else {
                this.items = this.items.map((num) => num - 1);
            }
            this.selectedItem = this.items[5];

        }
    }

    private checkDistance($event: NumberPickerEvent): number {
        let count = 1;
        if ($event.distance > 120) {
            count = 2
        }
        if ($event.distance > 180) {
            count = 3
        }
        if ($event.distance > 240) {
            count = 4
        }
        if ($event.distance > 300) {
            count = 5
        }
        if ($event.distance > 350) {
            count = 7;
        }
        return count;
    }

    private scrollDown($event: NumberPickerEvent): void {
        const countItems = this.checkDistance($event);
        for (let i = 0; i < countItems; i++) {
            if (!isNaN(this.data?.maxValue) && this.items[this.items.length - 5] > this.data?.maxValue) {
                return
            } else {
                this.items = this.items.map((num) => num + 1);
                this.selectedItem = this.items[5];
            }
        }
    }

    private setNumberPickerValue(pickedNum: number): void {
        this.items = [pickedNum];
        for (let i = 0; i < 5; i++) {
            this.items = [this.items[0] - 1, ...this.items, this.items[this.items.length - 1] + 1];
        }
    }
}

